import { createTheme, alpha } from '@mui/material/styles';

export const landingTheme = createTheme({
  palette: {
    mode: 'light',
    primary: { main: '#4f46e5', light: '#6366f1', dark: '#3730a3' },
    secondary: { main: '#0ea5e9', light: '#38bdf8', dark: '#0284c7' },
    success: { main: '#10b981' },
    background: { default: '#f8fafc', paper: '#ffffff' },
    text: { primary: '#0f172a', secondary: '#64748b' },
    divider: '#e2e8f0',
  },
  typography: {
    fontFamily: '"Inter", "SF Pro Display", "Segoe UI", sans-serif',
    h1: { fontWeight: 800, fontSize: 'clamp(2.25rem, 5vw, 3.5rem)', lineHeight: 1.08, letterSpacing: '-0.03em' },
    h2: { fontWeight: 800, fontSize: 'clamp(1.75rem, 3.5vw, 2.5rem)', lineHeight: 1.15, letterSpacing: '-0.025em' },
    h3: { fontWeight: 700, fontSize: '1.35rem', lineHeight: 1.25 },
    h6: { fontWeight: 600 },
    body1: { fontSize: '1.0625rem', lineHeight: 1.7 },
    body2: { fontSize: '0.9375rem', lineHeight: 1.65 },
    overline: { fontWeight: 700, letterSpacing: '0.12em', fontSize: '0.7rem' },
  },
  shape: { borderRadius: 12 },
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          borderRadius: 10,
          textTransform: 'none',
          fontWeight: 600,
          padding: '10px 22px',
          boxShadow: 'none',
        },
        containedPrimary: {
          '&:hover': { boxShadow: '0 8px 24px -8px rgba(79, 70, 229, 0.55)' },
        },
      },
    },
    MuiCard: {
      styleOverrides: {
        root: {
          borderRadius: 16,
          border: `1px solid ${alpha('#0f172a', 0.06)}`,
          boxShadow: '0 1px 2px rgba(15, 23, 42, 0.04)',
        },
      },
    },
  },
});

export const sectionSx = {
  py: { xs: 8, md: 12 },
};